import { SUPPORT_EMAIL } from "../legal/company.js";
import {
  PILLARS,
  PILLARS_EYEBROW,
  PILLARS_HEADING,
  POSITIONING_LINE,
  ROOF_LINE,
  SUPPORT_ANCHOR,
  SUPPORT_BODY,
  SUPPORT_HEADING,
} from "../site-copy.js";
import { sectionHead } from "./chrome.js";
import { h } from "./dom.js";

/**
 * The two launch-doc sections the hub and `/about` both carry: what the app
 * does, and how to reach a person about it.
 *
 * They are rendered here once rather than on each page, so the two pages cannot
 * drift apart — and so the `#support` anchor, which the App Store support URL
 * will point at, exists on exactly the elements that carry the address. The
 * words themselves are in `src/site-copy.ts`; this file is markup only.
 */

/** The three pillars, from the approved copy. Shipped features only. */
export function pillarsSection(): HTMLElement {
  return h(
    "section",
    { class: "section pillars-section", "aria-labelledby": "pillars-title" },
    sectionHead(PILLARS_HEADING, PILLARS_EYEBROW),
    h("p", { class: "lede", id: "pillars-title", text: ROOF_LINE }),
    h(
      "ul",
      { class: "pillars" },
      ...PILLARS.map((pillar) =>
        h(
          "li",
          { class: "pillar" },
          h("h3", { class: "pillar-title", text: pillar.title }),
          h("ul", { class: "pillar-items" }, ...pillar.items.map((item) => h("li", { text: item }))),
        ),
      ),
    ),
    h("p", { class: "note", text: POSITIONING_LINE }),
  );
}

/**
 * The support section.
 *
 * `id="support"` is a published contract, not a styling hook: the App Store
 * support URL is `https://arrowchess.com/#support` (launch doc §3). The address
 * is a `mailto:` and also readable as text, because a reader on a machine with
 * no mail client configured still needs to be able to copy it.
 */
export function supportSection(): HTMLElement {
  return h(
    "section",
    { class: "section", id: SUPPORT_ANCHOR, tabindex: -1 },
    sectionHead(SUPPORT_HEADING),
    h(
      "p",
      {},
      SUPPORT_BODY.split(SUPPORT_EMAIL)[0] ?? "",
      h("a", { href: `mailto:${SUPPORT_EMAIL}`, text: SUPPORT_EMAIL }),
      SUPPORT_BODY.split(SUPPORT_EMAIL)[1] ?? "",
    ),
  );
}
